<ng-template #emailConfirmationModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Confirming your Email</h4>
        <button type="button" class="btn-close" aria-label="Close" title="Close Modal" (click)="modal.dismiss('Cross click');formReset()"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="formGroupOtp" (keydown)="enterKeyPress($event)">

        <h5 class="modal-info-text light">We have sent you a verification code to your email.</h5>
        <h5 class="modal-info-text light">
            Please check your email and fill in the code below.
            <br><br>
            Please check your spam box just in case!
        </h5>
        <div class="otp-input-wrap">
            <ng-otp-input [config]="{length:6, allowNumbersOnly: true}" (onInputChange)="onOtpChange($event)" [formCtrl]="formGroupOtp.controls['OTP']"></ng-otp-input>
            <div *ngIf="formGroupOtp && formGroupOtp.invalid && formGroupOtp.touched">
                <div [ngClass]="formGroupOtp && formGroupOtp.invalid ? 'invalid-feedback d-block':''" *ngIf="formGroupOtp.controls['OTP'].errors?.['required']"> Please enter OTP</div>
                <div [ngClass]="formGroupOtp && formGroupOtp.invalid ? 'invalid-feedback d-block':''" *ngIf="formGroupOtp.controls['OTP'].errors?.['minlength']"> Must be enter 6 number</div>
            </div>

        </div>
        <div class="btn-grps">
                <app-button [btnText]="'Verify OTP'" [btnTitle]="'Verify OTP'" [btnCss]="'btn btn-primary w-100 btn-lg'" [isDisable]="isDisableVerifyOTPBtn" (onBtnClick)="openModal($event,resetPasswordComponent.resetPasswordTemplate)"></app-button>
                <app-button [btnText]="'Didn’t Get OTP?'" [btnTitle]="'Didn’t Get OTP?'" [btnCss]="'btn btn-text w-100 btn-md'" (onBtnClick)="openModal($event,otpNotRecievedComponent.otpNotRecievedTemplate, 'email-confirmation-Modal');"></app-button>

        </div>
        </form>
    </div>
</ng-template>

<app-reset-password #resetPasswordModal [resetCode]="resetCode" [modalReference]="modalReference"></app-reset-password>
<app-otpnotreceived #otpNotReceivedModal (onResendOTP)="onResendClick()" [isDisableResendBtn]="isDisableResendBtn"></app-otpnotreceived>
